module.exports = __webpack_public_path__ + "static/media/exclusive.45641771.svg";